module.exports = __webpack_public_path__ + "static/media/arrow-right.eef567e9.svg";